/**
 * Shared selected/cheapest-then-lead-in package fields for offer-page cancellation surfaces
 * (USP + desktop timeline experiment).
 */
export function getOfferCancellationPolicySelection(
  offer: App.HotelOffer | App.Offer,
  cheapestSelectedOption?: App.OfferPackageOptionView,
): {
  cancellationPolicy: App.OfferCancellationPolicy | undefined
  charterNights: number | undefined
} {
  const selectedPackage = cheapestSelectedOption?.package
  const leadInPackage = 'lowestPricePackage' in offer ? offer.lowestPricePackage : undefined

  return {
    cancellationPolicy: selectedPackage?.roomRate?.cancellationPolicy
      ?? leadInPackage?.roomRate?.cancellationPolicy,
    charterNights: selectedPackage?.duration ?? leadInPackage?.duration,
  }
}
